import { useDispatch, useSelector } from 'react-redux';
import { setQuizUserSelection } from '../../redux/data/dataSlice';
import CheckIcon from "../../assets/images/check.svg";
import XIcon from "../../assets/images/close.svg";

function QuizQuestions(props) {
    const dispatch = useDispatch();
    const userSelections = useSelector(state => state.data.quizUserSelections);
    const quizCompleted = useSelector(state => state.data.quizSubmissionSuccess);
    const questions = props && props.questions;
    const currentQuestionIndex = props && props.current;
    const reviewing = props && props.current && props.current === questions.length;
    const rectangularImgs = props && props.rectangularImgs;
    const isMobileView = props && props.isMobileView;

    const handleRadioSelection = (questionIndex, questionId, answerId) => {
        let selections = [...userSelections];

        selections[questionIndex] = {
            question_id: questionId,
            selected_answers: [answerId],
            text_answer: null,
            other: null
        };
        props.setQuizError(false);
        dispatch(setQuizUserSelection(selections));
    };

    const handleCheckboxSelection = (questionIndex, questionId, answerId) => {
        let selections = [...userSelections];

        if (!selections[questionIndex]) {
            selections[questionIndex] = {
                question_id: questionId,
                selected_answers: [answerId],
                text_answer: null,
                other: null
            };
        } else {
            if (!selections[questionIndex].selected_answers) {
                selections[questionIndex].selected_answers = [answerId];
            } else {
                let answers = [...selections[questionIndex].selected_answers];
                let index = answers.indexOf(answerId);
                if (index === -1) {
                    answers.push(answerId);
                } else {
                    answers.splice(index, 1);
                }

                selections[questionIndex] = {
                    question_id: questionId,
                    selected_answers: answers,
                    text_answer: null,
                    other: null
                };
            }
        }

        props.setQuizError(false);
        dispatch(setQuizUserSelection(selections));
    };

    const checkboxIsChecked = (questionIndex, answerID) => {
        if (userSelections[questionIndex] && userSelections[questionIndex].selected_answers) {
            return userSelections[questionIndex].selected_answers.includes(answerID);
        }
        return false;
    };

    const radioIsChecked = (questionIndex, answerID) => {
        if (userSelections[questionIndex] && userSelections[questionIndex].selected_answers) {
            return userSelections[questionIndex].selected_answers[0] === answerID;
        }
        return false;
    };

    return questions.map((question, questionIndex) =>
        <div className={`modal-quiz-question${questionIndex === currentQuestionIndex || reviewing || quizCompleted ? ' active' : ''}`} key={questionIndex}>
            <div className="modal-quiz-question-text">{question.value}</div>
            {(() => {
                const threeColumns = question.answer_options && question.answer_options.length > 4;
                const hasImages = question.answer_options && question.answer_options[0] && question.answer_options[0].image_url;
                const classes = `modal-options ${!hasImages ? ' no-images' : rectangularImgs ?
                    ' rectangular-img-options' : threeColumns && !isMobileView ? ' three-col' : ' two-col'} ${reviewing ?
                    ' reviewing' : ''} ${quizCompleted ? ' quiz-completed' : ''}`;

                switch(question.question_type) {
                    case 'select_one':
                        return (
                            <div className={classes}>
                            { question.answer_options.map((answer, answerIndex) => {
                                let correctAnswer = quizCompleted && question.correct_answer === answer.id;
                                let answerIsCorrect = quizCompleted && userSelections[questionIndex] && userSelections[questionIndex].selected_answers &&
                                    userSelections[questionIndex].selected_answers[0] === question.correct_answer && question.correct_answer === answer.id;
                                let answerIsIncorrect = quizCompleted && userSelections[questionIndex] && userSelections[questionIndex].selected_answers &&
                                    userSelections[questionIndex].selected_answers[0] === answer.id && userSelections[questionIndex].selected_answers[0] !== question.correct_answer;

                                return (
                                    <div className={`modal-answer-option ${answerIsIncorrect ? 'incorrect-answer' : ''} ${answerIsCorrect || correctAnswer ? 'correct-answer' : ''}`} key={answerIndex}>
                                        {quizCompleted && hasImages && answerIsIncorrect && <div className='in-correct-answer-check'>
                                            <img src={XIcon} alt='incorrect-answer'/>
                                        </div>
                                        }
                                        {quizCompleted && hasImages && (answerIsCorrect || correctAnswer) && <div className='in-correct-answer-check'>
                                            <img src={CheckIcon} alt='correct-answer'/>
                                        </div>
                                        }
                                        <div className={`modal-answer-option-input ${hasImages ? 'has-images' : 'no-images'} ${quizCompleted ? 'quiz-completed' : ''}`}>
                                            <input type="radio" name={`question_${questionIndex}_option`} id={`question_${questionIndex}_option_${answerIndex}`} value={answer.id}
                                                checked={radioIsChecked(questionIndex, answer.id)} className="modal-radio" onChange={() => handleRadioSelection(questionIndex, question.id, answer.id)}
                                                disabled={quizCompleted} />
                                            <label className="modal-answer-option-lbl" htmlFor={`question_${questionIndex}_option_${answerIndex}`}>
                                                {answer.value}
                                            </label>
                                            {quizCompleted && !hasImages && answerIsIncorrect && <div className='in-correct-answer-check no-images'>
                                                <img src={XIcon} alt='incorrect-answer'/>
                                            </div>
                                            }
                                            {quizCompleted && !hasImages && (answerIsCorrect || correctAnswer) && <div className='in-correct-answer-check no-images'>
                                                <img src={CheckIcon} alt='correct-answer'/>
                                            </div>
                                            }
                                        </div>
                                        { hasImages &&
                                            <label htmlFor={`question_${questionIndex}_option_${answerIndex}`}>
                                            { props.rectangularImgs ?
                                                <img src={answer.image_url} alt={answer.value} />
                                                :
                                                <div className="modal-answer-option-img" style={{ backgroundImage: `url("${answer.image_url}")` }}
                                                alt={answer.value}></div>
                                            }
                                            </label>
                                        }
                                    </div>);
                            })}
                            </div>
                        );
                    case 'select_multiple':
                    default:
                        return (
                            <div className={classes}>
                            { question.answer_options.map((answer, answerIndex) => {
                                let answerIsCorrect = false;
                                let answerIsIncorrect = false;
                                let correctAnswer = quizCompleted && question.correct_answer.some(el => el === answer.id);
                                if (quizCompleted && userSelections[questionIndex] && userSelections[questionIndex].selected_answers) {
                                    let correctIndex = question.correct_answer.indexOf(answer.id);
                                    let selectedIndex = userSelections[questionIndex].selected_answers.indexOf(answer.id);

                                    if (correctIndex !== -1) {
                                        answerIsCorrect = true;
                                        answerIsIncorrect = false;
                                    } else {
                                        if (selectedIndex !== -1) {
                                            answerIsCorrect = false;
                                            answerIsIncorrect = true;
                                        }
                                    }
                                }

                                return (
                                    <div className={`modal-answer-option ${answerIsIncorrect ? 'incorrect-answer' : ''} ${answerIsCorrect || correctAnswer ? 'correct-answer' : ''}`} key={answerIndex}>
                                        {quizCompleted && hasImages && answerIsIncorrect && <div className='in-correct-answer-check'>
                                            <img src={XIcon} alt='incorrect-answer'/>
                                        </div>
                                        }
                                        {quizCompleted && hasImages && (answerIsCorrect || correctAnswer) && <div className='in-correct-answer-check'>
                                            <img src={CheckIcon} alt='correct-answer'/>
                                        </div>
                                        }<div className={`modal-answer-option-input ${hasImages ? 'has-images' : 'no-images'} ${quizCompleted ? 'quiz-completed' : ''}`}>
                                            <input type="checkbox" name={`question_${questionIndex}_option`} id={`question_${questionIndex}option_${answerIndex}`} value={answer.id}
                                                checked={checkboxIsChecked(questionIndex, answer.id)} className="modal-checkbox" onChange={() => handleCheckboxSelection(questionIndex, question.id, answer.id)}
                                                disabled={quizCompleted} />
                                            <label className="modal-answer-option-lbl" htmlFor={`question_${questionIndex}option_${answerIndex}`}>
                                                {answer.value}
                                            </label>
                                            {quizCompleted && !hasImages && answerIsIncorrect && <div className='in-correct-answer-check no-images'>
                                                <img src={XIcon} alt='incorrect-answer'/>
                                            </div>
                                            }
                                            {quizCompleted && !hasImages && (answerIsCorrect || correctAnswer) && <div className='in-correct-answer-check no-images'>
                                                <img src={CheckIcon} alt='correct-answer'/>
                                            </div>
                                            }
                                        </div>
                                        { hasImages &&
                                            <label htmlFor={`question_${questionIndex}option_${answerIndex}`}>
                                            { props.rectangularImgs ?
                                                <img src={answer.image_url} alt={answer.value} />
                                                :
                                                <div className="modal-answer-option-img" style={{ backgroundImage: `url("${answer.image_url}")` }}
                                                alt={answer.value}></div>
                                            }
                                            </label>
                                        }
                                    </div>);
                            })}
                            </div>
                        );
            }})()}
        </div>
    );
}

export default QuizQuestions;
